// extracted by mini-css-extract-plugin
export var blockedMessage = "_96-3";
export var blockedOverlay = "_96-1";
export var fadeIn = "_96-2";
export var hereLink = "_96-0";
export var slideUp = "_96-4";